export default "__VITE_ASSET__B4Us2Aw1__"